import Vue from 'vue'
import VueI18n from 'vue-i18n'
import App from './App.vue'
import router from './router'
import store from './store'
import messages from './messages'
import { getUserLanguage } from './lib/lang'
import { auth } from './firebase'
import config from './config'
import './assets/sass/main.scss'
Vue.use(VueI18n)
Vue.config.productionTip = false

const env = process.env.VUE_APP_ENV
Vue.prototype.$config = { ...config.default, ...config[env] }

const i18n = new VueI18n({
  locale: getUserLanguage(),
  fallbackLocale: 'en',
  messages
})

let app
auth.onAuthStateChanged(async user => {
  if (!app) {
    app = new Vue({
      i18n,
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  }
  if (user) {
    await store.dispatch('auth/fetchAuthData')
    await store.dispatch('user/fetchUserParams', user)
    await store.dispatch('auth/connect', true)
    if (app.$route.query.to || app.$route.name !== 'home') app.$router.replace(app.$route.query.to ? { name: app.$route.query.to } : { name: 'home' })
  } else {
    app.$router.replace({ name: 'login', query: { to: app.$route.name === 'login' ? 'home' : app.$route.name } })
  }
})
